import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-swiper-pagination',
    styleUrls: ['./swiper-pagination.component.scss'],
    templateUrl: './swiper-pagination.component.html',
    standalone: false
})
export class SwiperPaginationComponent {
  @Input() wrapPagination = true;
  @Input() items: any[];
  @Input() activeIndex: number;
  @Output() changeIndex: EventEmitter<number> = new EventEmitter();

  updateIndex(index) {
    let newIndex = index;
    if (this.wrapPagination) {
      newIndex %= (this.items || []).length;
    } else {
      newIndex = Math.min(this.items.length, newIndex);
    }
    if (newIndex < 0) {
      newIndex = this.wrapPagination ? this.items.length : 0;
    }
    this.changeIndex.emit(newIndex);
  }

  previous() {
    this.updateIndex((this.activeIndex || 0) - 1);
  }

  next() {
    this.updateIndex((this.activeIndex || 0) + 1);
  }
}
